
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface FieldParameterValues {
    maxFieldSize: number;
    aBracketSize: number;
    cBracketSize: number;
}

@Component({
    selector: 'app-field-parameters-modal',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './field-parameters-modal.component.html',
    styleUrls: ['./field-parameters-modal.component.scss']
})
export class FieldParametersModalComponent {
    @Output() fieldParametersSaved = new EventEmitter<FieldParameterValues>();

    isVisible = false;

    form: FieldParameterValues = {
        maxFieldSize: 120,
        aBracketSize: 60,
        cBracketSize: 0
    };

    openModal(values: FieldParameterValues): void {
        this.form = { ...values };
        this.isVisible = true;
    }

    closeModal(): void {
        this.isVisible = false;
    }

    save(): void {
        const normalized: FieldParameterValues = {
            maxFieldSize: Number(this.form.maxFieldSize) || 0,
            aBracketSize: Number(this.form.aBracketSize) || 0,
            cBracketSize: Number(this.form.cBracketSize) || 0
        };

        this.fieldParametersSaved.emit(normalized);
        this.closeModal();
    }

    get bBracketSize(): number {
        const { maxFieldSize, aBracketSize, cBracketSize } = this.form;
        const result = Number(maxFieldSize) - Number(aBracketSize) - Number(cBracketSize);
        return Number.isNaN(result) ? 0 : result;
    }
}
